// Package LINE ITEMS and PIECES are two different numbers and an operator has to
// be able to tell which one they are looking at. The shipment inspector counted
// lines ("1 package loaded") while Document Studio summed quantities ("8 PCS"),
// so the same shipment appeared to hold a different amount of freight depending
// on the screen. AWB paperwork is counted in pieces, so pieces stay authoritative
// on documents — this module just makes both figures come from one rule,
// including the "a line with no quantity is one piece" fallback.

export const countPackageLines = (packages) =>
  Array.isArray(packages) ? packages.length : 0;

export const countPackagePieces = (packages) =>
  (Array.isArray(packages) ? packages : []).reduce(
    (total, pkg) => total + (Number(pkg?.quantity) || 1),
    0
  );

/** Inspector-facing label, e.g. "2 lines · 8 pcs". */
export const describePackageTotals = (packages) => {
  const lines = countPackageLines(packages);
  if (!lines) return "No packages loaded";
  const pieces = countPackagePieces(packages);
  return `${lines} line${lines === 1 ? "" : "s"} · ${pieces} pcs`;
};
